import cx from 'classnames';
import React, { forwardRef, ReactNode } from 'react';

import RoundedPlateDivider, { DIVIDER_VIEW } from './__divider/rounded-plate__divider';

import './rounded-plate.scss';

interface Props {
    children: ReactNode;
    mix?: string;
}

const RoundedPlate = forwardRef(({ children, mix }: Props, ref?: React.Ref<HTMLDivElement>) => {
    return (
        <div className={cx('rounded-plate', mix)} ref={ref}>
            {children}
        </div>
    );
});

export default Object.assign({}, RoundedPlate, { Divider: RoundedPlateDivider, DIVIDER_VIEW });
